import React from "react";
const CardBack = () => {
  return (
    <>
      <div className="cardBack">
        <h4>/JP</h4>
        <p>CASINO</p>
      </div>
    </>
  );
};

export default CardBack;
